import Button from '@rio-cloud/rio-uikit/Button';
import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';
import { useCallback, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field } from 'redux-form';

import { toIntegerInBetween } from '../../normalization/toIntegerInBetween';
import SliderWithInput from '../common/formInputs/SliderWithInput';
import { AddressDisplay } from './AddressDisplay';
import CircleFormAddressSearchContainer from './addressSearch/CircleFormAddressSearchContainer';
import { EditAlert } from './EditAlert';
import { geofenceFormElements } from './GeofenceForm';

const radiusMaxValue = 80000;
const radiusMinValue = 25;

type CircularFormOptionsProps = {
    isCircular: boolean;
    editMode: boolean;
    onCenterMap: () => void;
};

export const CircularFormOptions = ({ isCircular, editMode, onCenterMap }: CircularFormOptionsProps) => {
    const [radiusValid, setRadiusValid] = useState(true);

    // Use a call back to avoid this. https://github.com/redux-form/redux-form/issues/4705
    const validateRadius = useCallback(() => (radiusValid ? undefined : 'Required'), [radiusValid]);

    const onCenter = useCallback(() => {
        onCenterMap();
    }, [onCenterMap]);

    const normalizeRadiusBetween: (value: number) => undefined | number | 0 = (value: number) =>
        toIntegerInBetween(radiusMinValue, radiusMaxValue)(value);

    const intl = useIntl();

    if (!isCircular) {
        return null;
    }

    return (
        <div>
            {editMode && <EditAlert />}
            {!editMode && (
                <>
                    <div className='margin-bottom-15'>
                        <label>
                            <FormattedMessage id='intl-msg:address' />
                        </label>
                        <Field
                            name={geofenceFormElements.geofenceAddress}
                            component={editMode ? AddressDisplay : CircleFormAddressSearchContainer}
                        />
                    </div>

                    <div className='margin-bottom-15'>
                        <label>
                            <FormattedMessage id='intl-msg:radius' />
                        </label>
                        <Field
                            name={geofenceFormElements.geofenceRadius}
                            component={SliderWithInput}
                            maxValue={radiusMaxValue}
                            minValue={radiusMinValue}
                            setValid={setRadiusValid}
                            validate={validateRadius}
                            normalize={normalizeRadiusBetween}
                            disabled={editMode}
                        >
                            {!editMode && (
                                <div className='margin-left-10'>
                                    <SimpleTooltip
                                        content={intl.formatMessage({ id: 'intl-msg:geofence.center-map' })}
                                        placement='top-end'
                                    >
                                        <Button
                                            onClick={onCenter}
                                            data-testid='center-map-button'
                                            iconName='position'
                                            iconOnly
                                        />
                                    </SimpleTooltip>
                                </div>
                            )}
                        </Field>
                    </div>
                </>
            )}
        </div>
    );
};
